import { useEffect, useRef, useState, useCallback } from 'react';
import { useShowAds } from '../hooks/useShowAds';

const AD_SLOTS = {
  ADBANNER1: '3890411296', // Kept for easy switch back to AdSense
  ADBANNER3: '6488654474',
  ADBANNER4: '6584382034',
};

const AD_CLIENT = 'ca-pub-4683440830169407';

const AdSenseBanner = ({ slot, testId, maxWidth, onFillChange }) => {
  const { showAds } = useShowAds();
  const containerRef = useRef(null);
  const insRef = useRef(null);
  const initializedRef = useRef(false);
  const [pushed, setPushed] = useState(false);
  const [adFilled, setAdFilled] = useState(null); // null = unknown, true = filled, false = unfilled

  // Lazy-load: initialize ad slot when near viewport
  useEffect(() => {
    if (!showAds || initializedRef.current) return;
    const node = containerRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !initializedRef.current) {
          initializedRef.current = true;
          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (e) {
            // AdSense not ready
          }
          setPushed(true);
          observer.disconnect();
        }
      },
      { rootMargin: '300px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [showAds]);

  // After push, watch <ins> for data-ad-status to detect fill
  useEffect(() => {
    if (!pushed) return;
    const ins = insRef.current;
    if (!ins) return;

    const checkStatus = () => {
      const status = ins.getAttribute('data-ad-status');
      if (status === 'filled') {
        setAdFilled(true);
        onFillChange?.(true);
      } else if (status === 'unfilled') {
        setAdFilled(false);
        onFillChange?.(false);
      }
    };

    checkStatus();
    const obs = new MutationObserver(checkStatus);
    obs.observe(ins, { attributes: true, attributeFilter: ['data-ad-status'] });
    return () => obs.disconnect();
  }, [pushed, onFillChange]);

  if (!showAds) return null;

  // Visible while waiting for init + status check. Hidden only when confirmed unfilled.
  const hidden = adFilled === false;

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      style={{
        maxWidth: maxWidth || undefined,
        display: hidden ? 'none' : 'block',
      }}
      className={maxWidth ? 'mx-auto' : undefined}
    >
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format="horizontal"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export { AD_SLOTS };
export default AdSenseBanner;
